import Vue from 'vue';
import '@/assets/stylesheets/v2/_category-details.scss';
import ActionButton from '@/components/action_button/Index.vue';
import PhotoMixin from '@/helpers/vue_mixins/v2/PhotoMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
export default Vue.extend({
    mixins: [PhotoMixin, ViewportSizeMixin],
    props: {
        header: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        imageUrl: {
            type: String,
            default: null,
        },
    },
    computed: {
        hasImage() {
            return !!this.imageUrl;
        },
    },
    render(createElement) {
        const self = this;
        const elements = [
            createElement('v-flex', { class: 'shrink' }, [
                createElement('div', {
                    class: {
                        wrapper: true,
                        '-padded': !self.hasImage,
                        '-has-margin': self.xsOnly,
                    },
                }, [
                    createElement('v-img', {
                        class: 'image',
                        props: {
                            src: self.featuredPhotoUrl(self.imageUrl),
                            contain: !self.hasImage,
                        },
                    }),
                ]),
            ]),
            createElement('v-flex', [
                createElement('div', {
                    class: 'header',
                }, this.header),
                createElement('div', {
                    class: { description: self.smAndUp, 'description -mobile': self.xsOnly },
                }, this.description),
            ]),
            createElement('v-flex', { class: 'shrink hidden-xs-only' }, [
                createElement(ActionButton, {
                    props: {
                        edit: true,
                    },
                    on: {
                        wasClicked: () => self.$emit('edit'),
                    },
                }, [createElement('v-icon', { props: { left: true } }, 'edit'), 'Edit']),
            ]),
        ];
        const mobileButton = [
            createElement('v-flex', { class: 'text-xs-right hidden-sm-and-up mt-4' }, [
                createElement(ActionButton, {
                    props: {
                        edit: true,
                        smBtn: self.xsOnly,
                    },
                    on: {
                        wasClicked: () => self.$emit('edit'),
                    },
                }, [createElement('v-icon', { props: { left: true } }, 'edit'), 'Edit']),
            ]),
        ];
        return createElement('v-card', {
            class: 'category-details',
        }, [createElement('v-layout', elements), createElement('v-layout', mobileButton)]);
    },
});
